import { Injectable, inject } from '@angular/core';
import { ApiDependencyProviderService, HttpParams } from '@web/common';
import { Observable } from 'rxjs';
import { OrderNumber } from '../../../shared/types';

@Injectable({
  providedIn: 'root',
})
export class PublicInvoiceApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  public downloadInvoice(number: OrderNumber): Observable<Blob> {
    const path = `order/${HttpParams.Number}/invoice/download`;
    const url = this.provider.httpUrlFactory.withParams(this.hostUrl(), path, {
      [HttpParams.Number]: number,
    });

    const context = this.provider.httpContextBuilder
      .skipByLoadingInterceptor()
      .build();

    return this.provider.http.get(url, {
      context,
      responseType: 'blob',
    });
  }

  public downloadTemporaryInvoice(number: OrderNumber): Observable<Blob> {
    const path = `order/${HttpParams.Number}/invoice/temporary/download`;
    const url = this.provider.httpUrlFactory.withParams(this.hostUrl(), path, {
      [HttpParams.Number]: number,
    });

    const context = this.provider.httpContextBuilder
      .skipByLoadingInterceptor()
      .build();

    return this.provider.http.get(url, {
      context,
      responseType: 'blob',
    });
  }

  public downloadRefundInvoice(number: OrderNumber): Observable<Blob> {
    const path = `refund/${HttpParams.Number}/invoice/download`;
    const url = this.provider.httpUrlFactory.withParams(this.hostUrl(), path, {
      [HttpParams.Number]: number,
    });

    const context = this.provider.httpContextBuilder
      .skipByLoadingInterceptor()
      .build();

    return this.provider.http.get(url, {
      context,
      responseType: 'blob',
    });
  }

  private hostUrl(): string {
    return this.provider.environment.ApiHostUrl.Shop;
  }
}
